import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { AuthProvider } from 'src/app/providers/auth.provider';
import { HelperProvider } from 'src/app/providers/helper.provider';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-device-list',
  templateUrl: './device-list.page.html',
  styleUrls: ['./device-list.page.scss'],
})
export class DeviceListPage implements OnInit {

  deviceList = [];
  userData: any;
  defaultOffice = '64faefc488863301c2d53f93';
  loading = false;
  SENSOR_USER = "653a5390fa2fae002cbb9d39";

  constructor(
    private helperProvider: HelperProvider,
    private alertController: AlertController,
    private authProvider: AuthProvider,
    private router: Router
  ) { }

  ngOnInit() {
    // this.getUserData();
    // this.getDeviceList();
  }

  ionViewWillEnter() {
    console.log("Enter vla");
    this.getUserData();
    this.getDeviceList();
  }

  getUserData() {
    if (localStorage.getItem("ngStorage-profile")) {
      this.userData = JSON.parse(localStorage.getItem("ngStorage-profile"))
    }
  }

  async getDeviceList() {
    this.loading = true;
    this.deviceList = await this.getMyData({ type: 'getList', subType: 'userDeviceList', officeId: this.defaultOffice, regId: this.SENSOR_USER, filter: { profileId: this.userData.profileId }, sort: { _id: 1 } });
    this.loading = false;
  }

  async getMyData(data) {
    try {
      return await this.helperProvider.postRequest(`${environment.serverUrl}api/get-my-data`, data);
    } catch (error) {
      console.log("error in my data call", error);
      this.showAlert(error);
      return null;
    }
  }

  async showAlert(message: any) {
    return new Promise(async (resolve, reject) => {
      const alert = await this.alertController.create({
        header: message,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              resolve(null);
            }
          },
          {
            text: 'OK',
            handler: (data) => {
              resolve(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  itemClicked(item) {
    if (item.senId) {
      this.router.navigateByUrl(`/device/${item.senId}`);
    }
  }

  logout() {
    this.authProvider.logout();
  }

  
  profileView() {
    this.router.navigateByUrl('/profile');
  }

}
